import React, {Component} from 'react';
import BaseComponent from "../../../base/BaseComponent";
import CmModal from "../../../components/CmModal/CmModal";
import {uuid, validateName} from "../../../utils";
import CmForm from "../../../components/CmForm/CmForm";
import {message} from "../../../view/sysManagement/utils/sysManagementUtils";
import {Form, Input, InputNumber, Select, Radio} from "antd";
import ButtonInput from "../../../view/sysManagement/selectedTopicManagement/formContent/buttonInput";
import UploadWall from "../../../components/upload/UploadWall";
import {PIC_TYPE_ORIGINAL} from "../../../constants";
import ChunkUpload from "../../../components/upload/ChunkUpload";
import PictureNormalFileItem from "../../../components/upload/fileItem/PictureNormalFileItem";

const FormItem = Form.Item;
const {Option} = Select;

class MenuEditModal extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            editData: null,
            fileList:[],
            key:""
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.visible && this.props.visible !== prevProps.visible) {
            this.uid = uuid();
            this.setState({
                fileList:[],
                editData: this.initData(this.props.data || {})
            }, ()=>{
                this.getFileInfo();
            });
        }
    }

    getFileInfo(){
        let path = this.state.editData?.url?.value;
        if(path){
            this.request({
                url : "/storage/getByPath?path="+path,
                callBack: (data)=>{
                    if(data){
                        data.status = "done";
                        data.percent = 100;
                        data.originFileObj = {};
                        data.response = { path};
                        Object.assign(data.originFileObj, data);
                        this.setState({fileList:[data]})
                    }
                }
            })
        }
    }

    handleChangeFileList = (info) => {
        info.fileList = info.fileList.map(item => {
            // 取决于需要什么数据填入fileList
            if (item.uid === info.file.uid) {
                if(info.file.response && info.file.response.data){
                    //分片上传是走的自己封装的接口 所以返回值只有data
                    //直接上传走的是antd的接口，所以返回值还有一个data属性包裹着的。这里主要是兼容两种返回值
                    info.file.response = {...info.file.response.data, ...info.file.response};
                    item.response = info.file.response;
                }
                item.uid = info.file.uid;
                item.ext = info.file.response && info.file.response.suffix;
                item.url = info.file.response && info.file.response.path;
                item.path = info.file.response && info.file.response.path;
                item.name = info.file.response && info.file.response.name;
                item.isChunk = true;
                item.status = info.file.status;
                item.md5 = info.file.originFileObj && info.file.originFileObj.md5;
                item.id = info.file.response && info.file.response._id;
            }
            return item;
        });
        if(info.fileList.length>0 && info.fileList[0].url){
            this.onDataChange({url : info.fileList[0].url})
        }
        this.setState({fileList:info.fileList});
    };

    render() {
        const {
            visible
        } = this.props;

        const {editData} = this.state;
        // 选择视频栏目时展示展示方式
        let showType = editData && editData["type"] && editData["type"].value === 3;

        if (!editData) {
            return null;
        }
        const isCreate = !editData.id.value;
        const onDataChange = this.onDataChange;
        return (
            <CmModal
                title={isCreate ? "添加栏目" : "修改栏目"}
                visible={visible}
                handleCancel={this.handleCancel}
                handleOk={this.handleOk}
                destroyOnClose={true}
                onScrollSelect={()=>{
                    this.setState({
                        key: uuid()
                    })
                }}
            >
                <CmForm>
                    <FormItem
                        label={editData.columnName.label}
                        required={editData.columnName.required}
                    >
                        <Input
                            placeholder={editData.columnName.placeholder}
                            onChange={e => onDataChange({columnName: e.target.value})} type="text"
                            value={editData.columnName.value}
                        />
                    </FormItem>
                    <FormItem
                        label={editData.columnCode.label}
                        required={editData.columnCode.required}
                    >
                        <Input
                            placeholder={editData.columnCode.placeholder}
                            onChange={e => onDataChange({columnCode: e.target.value})}
                            value={editData.columnCode.value}
                            disabled={!isCreate}
                        />
                    </FormItem>
                    <FormItem
                        label={editData.type.label}
                        required={editData.type.required}
                    >
                        <Select placeholder={editData.type.placeholder}
                                value={editData.type.value}
                                onChange={value=>{
                                    onDataChange({type: value})
                                }}
                        >
                            {Object.keys(editData.type.options).map((key, index)=>{
                                return <Option value={key * 1} key={index}>{editData.type.options[key]}</Option>
                            })}
                        </Select>
                    </FormItem>
                    <FormItem
                        className={"rm-column-edit-url-form-item"}
                        label={editData.url.label}
                        required={editData.url.required}
                    >
                        <UploadWall
                            showUploadDisplayBtn={true}
                            accept={"." + PIC_TYPE_ORIGINAL.join(",.")}
                            multiple={false}
                            action="/storage/uploadFile"
                            fileList={this.state.fileList}
                            style={{padding: "10px 0 0 0",width:"342px"}}
                            beforeUpload={(file) => {
                                let fileName = file.name.split('.');
                                let upload = fileName.at(-1);
                                upload = PIC_TYPE_ORIGINAL.includes(upload);
                                if (!upload) {
                                    message.error('暂不支持该文件类型！');
                                }
                                return new Promise((resolve, reject) => {
                                    if (!upload) {
                                        reject(file);
                                    } else {
                                        resolve(file);
                                    }
                                });
                            }}
                            customRequest={new ChunkUpload({
                                checkFileURL:"/storage/checkFile",
                                checkChunkURL:"/storage/checkChunk",
                                uploadChunkURL:"/storage/uploadChunk",
                                chunkUploadOverURL:"/storage/chunkIsUploadOver",
                                mergeChunksURL:"/storage/mergeChunk",
                                fileError:(md5, mergeResult, newFile)=>{}
                            }).start}
                            icons={this.props.showAddBtn?["eye", "delete"]:[]}
                            fileItemComponent={(file) => (props) => {
                                return <PictureNormalFileItem {...props} showEdit={false} />;
                            }}
                            showUploadBtn={this.state.fileList.length===0}
                            uploadBtnName={"点击上传"}
                            onChange={(info)=>this.handleChangeFileList(info)}
                            onRemove={()=>this.setState({fileList:[]},() => {
                                this.onDataChange({url : ""})
                            })}
                        />
                        <style>{`
                            .rm-column-edit-url-form-item{
                                margin-bottom: 0px !important;
                            }
                        `}</style>
                    </FormItem>
                    {showType ?
                        <FormItem
                            label={editData.videoShowType.label}
                            required={editData.videoShowType.required}
                        >
                            <Radio.Group value={editData.videoShowType.value}
                                         onChange={e => onDataChange({videoShowType: e.target.value})}>
                                <Radio value={1}>瀑布列表</Radio>
                                <Radio value={2}>小视频展示</Radio>
                            </Radio.Group>
                        </FormItem> : null}
                    <FormItem
                        label={editData.showStyle.label}
                        required={editData.showStyle.required}
                    >
                        <Radio.Group value={editData.showStyle.value} onChange={e=>onDataChange({showStyle:e.target.value})}>
                            <Radio value={1}>是</Radio>
                            <Radio value={2}>否</Radio>
                        </Radio.Group>
                    </FormItem>
                    <FormItem
                        label={editData.showDetail.label}
                        required={editData.showDetail.required}
                    >
                        <Radio.Group value={editData.showDetail.value} onChange={e=>onDataChange({showDetail:e.target.value})}>
                            <Radio value={true}>是</Radio>
                            <Radio value={false}>否</Radio>
                        </Radio.Group>
                    </FormItem>
                    <FormItem
                        label={editData.status.label}
                        required={editData.status.required}
                    >
                        <Radio.Group value={editData.status.value} onChange={e=>onDataChange({status:e.target.value})}>
                            <Radio value={1}>启用</Radio>
                            <Radio value={2}>禁用</Radio>
                        </Radio.Group>
                    </FormItem>
                    <FormItem
                        label={editData.permissionType.label}
                        required={editData.permissionType.required}
                    >
                        <Select placeholder={editData.permissionType.placeholder}
                                value={editData.permissionType.value}
                                onChange={value=>{
                                    onDataChange({permissionType: value})
                                }}
                        >
                            {Object.keys(editData.permissionType.options).map((key, index)=>{
                                return <Option value={key * 1} key={index}>{editData.permissionType.options[key]}</Option>
                            })}
                        </Select>
                    </FormItem>
                    {/*<FormItem*/}
                    {/*    label={editData.sort.label}*/}
                    {/*    required={editData.sort.required}*/}
                    {/*>*/}
                    {/*    <InputNumber*/}
                    {/*        placeholder={editData.sort.placeholder}*/}
                    {/*        onChange={sort => onDataChange({sort})}*/}
                    {/*        value={editData.sort.value || 0}*/}
                    {/*        min={0}*/}
                    {/*    />*/}
                    {/*</FormItem>*/}
                    {/*<ButtonInput key={"labels"+this.uid} firstClosable={false} label={editData.labels.label} itemValue={editData.labels.value} callBack={(data)=>{*/}
                    {/*    editData.labels.value = data;*/}
                    {/*}}/>*/}
                </CmForm>
            </CmModal>
        );
    }

    onDataChange = (data) => {
        const editData = this.state.editData;
        Object.keys(data).forEach(key => {
            editData[key].value = data[key];
        });
        //选择专栏及专栏下的子栏目时封面图必填
        editData["url"].required = this.props.data.treeData["type"] === 2;
        this.setState({});
    };

    handleOk = () => {
        const {editData} = this.state;
        const data = {};
        let editDataKeys = Object.keys(editData);
        for (let i = 0; i < editDataKeys.length; i++) {
            const key = editDataKeys[i];
            data[key] = editData[key].value;
            //非视频栏目videoShowType为null
            if(key === "videoShowType" && editData["type"].value !== 3) data[key] = null;
            if (editData[key].required && editData[key].check && !editData[key].check(editData[key].value)) {
                return;
            }
        }
        if(this.state.fileList.length && this.state.fileList[0].status === "uploading") {
            message.warn("正在上传，请稍候！");
            return false;
        }
        this.props.handleOk(data);
    };

    handleCancel = () => {
        this.props.handleCancel();
    };

    uid = uuid();
    initData = (
        {
            id = "",
            columnName = "",
            columnCode = "",
            sort = 10,
            fid = "",
            url = "",
            type = 1,
            videoShowType = 1,
            showStyle = 2,
            showDetail = true,
            status = 1,
            permissionType = 1,
            labels = [],
            treeData = {}
        } = {}
    ) => {
        let editData = {
            id: {
                label: "栏目名称",
                value: id,
                required: true,
                placeholder: "栏目名称"
            },
            fid: {
                value: fid,
            },
            labels:{
                label: "标签",
                value: labels,
            },
            columnName: {
                label: "栏目名称",
                value: columnName,
                required: true,
                placeholder: "请输入栏目名称",
                check: (value) => {
                    if (!value) {
                        message.warn("请输入栏目名称！");
                        return false;
                    }
                    if (!validateName(value, {min: 1, max: 50})) {
                        message.warn("栏目名称最多50个字符，可使用中文、数字、字母、下划线！");
                        return false;
                    }
                    return true;
                }
            },
            columnCode: {
                label: "栏目编码",
                value: columnCode,
                required: true,
                placeholder: "请输入栏目编码",
                check: (value) => {
                    if (!value) {
                        message.warn("请输入栏目编码！");
                        return false;
                    }
                    if (!(/^[0-9a-zA-Z:_]{1,100}$/.test(value))) {
                        message.error("栏目编码只可填写字母、数字、下划线及冒号，限制输入100个字符！");
                        return false;
                    }
                    return true;
                }
            },
            type: {
                label: "栏目类型",
                value: type,
                required: true,
                placeholder: "请输入选择栏目类型",
                options: treeData.type === 2 ? {"1": "普通栏目"} :
                    {
                        "1": "普通栏目",
                        "2": "专题栏目",
                        "3": "视频栏目",
                    }
            },
            url:{
                label: "封面图片",
                value: url,
                required: treeData.type === 2,
                check: (value) => {
                    if (!value) {
                        message.warn("请上传封面图片！");
                        return false;
                    }
                    return true;
                }
            },
            videoShowType: {
                required: true,
                label: "展示方式",
                value: videoShowType,
            },
            showStyle: {
                required: true,
                label: "默认展示",
                value: showStyle,
            },
            showDetail: {
                required: true,
                label: "融媒号详情",
                value: showDetail,
            },
            status: {
                required: true,
                label: "状态",
                value: status,
            },
            permissionType: {
                label: "浏览限制",
                value: permissionType,
                required: true,
                placeholder: "请选择浏览限制",
                options: {
                    "1": "公开",
                    "2": "仅内部员工可见",
                    "3": "仅内部管理人员可见",
                }
            },
            sort: {
                label: "排序",
                value: sort,
                placeholder: "排序",
                check: value => {
                    value = value ? value + "" : 0;
                    if (value.length) {
                        if (!/^\d+$/.test(value)) {
                            message.error("排序只能输入自然数！");
                            return false;
                        }
                        if (parseInt(value, 10) > 9999) {
                            message.error("排序最大为9999！");
                            return false;
                        }
                    }
                    return true;
                }
            },
        };
        return editData;
    };
}

export default MenuEditModal;
